import type { Theme } from '@mui/material/styles';

const getIndustryColor = (industryName: string, theme: Theme): string => {
  const colorMap: Record<string, string> = {
    Autos: '#d32f2f',
    Banca: '#fbc02d',
    Seguros: theme.palette.success.main,
    Total: theme.palette.primary.main,
  };
  return colorMap[industryName] || theme.palette.secondary.main;
};

export default getIndustryColor;
